import { createFileRoute, redirect } from "@tanstack/react-router";

/** Legacy slug — permanent redirect to the canonical ES URL. */
export const Route = createFileRoute("/diagnosticador-locales")({
  beforeLoad: () => {
    throw redirect({ to: "/diagnostico-locales-comerciales", statusCode: 301 });
  },
});
